/**
 * 生词列表业务逻辑钩子
 * 封装生词列表相关的业务逻辑
 */
import { useVocabulary } from './useVocabulary.js';
/**
 * 生词列表业务逻辑钩子
 * 提供生词列表组件所需的数据和操作方法
 */
export function useVocabularyList(options = {}) {
    // 使用词汇钩子获取基础数据和操作
    const vocabularyData = useVocabulary(options);
    // 处理删除操作
    const handleDelete = async (id) => {
        try {
            await vocabularyData.deleteItem(id);
        }
        catch (error) {
            console.error('删除生词失败:', error);
            throw error;
        }
    };
    return {
        ...vocabularyData,
        handleDelete,
    };
}
//# sourceMappingURL=useVocabularyList.js.map